import React from "react";
import { FormGroup as StrapGroup, FormGroupProps as StrapGroupProps } from "reactstrap";


export interface ControlGroupProps extends StrapGroupProps {
    isLoading?: boolean | undefined
}

const ComponentProps = (props: ControlGroupProps): StrapGroupProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    
    return componentProps;
}

export const ControlGroup: React.FC<ControlGroupProps> = (props) => {
    if (props.isLoading ?? false) {
        return (
            <p className="placeholder-glow">
                <span className="placeholder col-12 placeholder-lg bg-secondary"></span>
            </p>
        );
    }

    return (
        <StrapGroup {...ComponentProps(props)} />
    );
};